/**
 * Test ID utilities for Checkbox component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for checkbox elements
 * @param identifier - Checkbox identifier (name, id, or 'unnamed')
 * @returns Test ID string
 */
export const setCheckboxTestId = (identifier: string): string =>
  generateTestId("Checkbox", identifier.replace(/\s+/g, "-").toLowerCase());
